import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmDialogData } from '../model/dialog-data.model';
import { ConfirmComponent, ConfirmDialogResult } from '../dialogs/confirm/confirm.component';
import { SelectFieldsComponent, SelectFieldsDialogData } from '../dialogs/select-fields/select-fields.component';
import { ICardSectionColumn } from '../interfaces/card-section.interface';


@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(
    public dialog: MatDialog,
  ) { }

  openConfirm(data: ConfirmDialogData, style?: { width?: string, height?: string }): Observable<ConfirmDialogResult> {
    return this.dialog
      .open(ConfirmComponent, {
        data,
        width: style?.width || 'fit-content',
        height: style?.height,
        minWidth: data?.minWidth || 'min(360px, calc(100vw - 32px))',
        minHeight: data?.minHeight,
        maxWidth: data?.maxWidth || 'min(520px, calc(100vw - 32px))',
        maxHeight: data?.maxHeight,
        //
        panelClass: ['[--mat-dialog-container-shape:16px]', ...(data.containerClass ? [data.containerClass].flat() : [])],
        disableClose: data.disableClose ?? true,
        autoFocus: false,
      })
      .afterClosed();
  }

  openSelectFields(
    existingFields: ICardSectionColumn[],
    customFields?: any[],
    funnelId?: string,
    entityType?: string,
  ): Observable<ICardSectionColumn[] | null> {
    return this.dialog
      .open(SelectFieldsComponent, {
        data: { existingFields, customFields, funnelId, entityType } as SelectFieldsDialogData,
        width: 'fit-content',
        minWidth: '400px',
        maxWidth: '600px',
        disableClose: false,
        autoFocus: false,
      })
      .afterClosed();
  }

}
